import { callApi } from '@/helpers/apiHelpers';
import { EventTypes } from '@/api-clients/main-api';

export interface IEventLoggerService {
  postEvent(eventType: EventTypes, parameters?: string): Promise<void>;
}

export class EventLoggerService implements IEventLoggerService {
  constructor(private getWorkspaceId: () => string) {}

  async postEvent(eventType: EventTypes, parameters?: string) {
    await callApi(api => api.postEvent(this.getWorkspaceId(), {
      eventType,
      guid: parameters,
      serviceInfo: undefined
    }));
  }
}
